<template>
  <div>
    <search-list
      @searchParams="search"
      :projectList="projectList"
      :sceneList="sceneList"
    ></search-list>
    <div >
      <Button type="primary" v-p="{api:'formulaConf/saveFormulaConf'}" @click.stop="addN++" class="mb16">新增</Button>
    </div>
    <add
      :n="addN"
      @done="getTableList"
      :projectList="projectList"
      :sceneList="sceneList"
      >
    </add>
    <table-list
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
    </table-list>
  </div>
</template>

<script>
import SearchList from './components/SearchList'
import Add from './components/Add'
import TableList from 'components/TableList/index';
import { getProjects } from 'api/common'
import { queryData, formulaConfListByPage , deleteFormulaConf , enableOrNot} from 'api/formulaconfig'
import {formatDateTime} from "../../../../utils/format"

export default {
  components: {
    SearchList,
    Add,
    TableList
  },
  data(){
    return{
      addN:0,
      data: [],
      loading:false,
      total:0,
      current:1,
      page:1,
      projectList:[],
      sceneList:[],
      roleList:[],
      limit:10,
      columns:[
        {
          title:'编号',
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title: '公式名称',
          align: 'center',
          key: 'formulaName',
          width: 150,
        },
        {
          title: ' '
        },
        {
          title: '项目名称',
          align: 'center',
          key: 'projectName',
          width: 120,
        },
        {
          title: ' '
        },
        {
          title: '应用场景',
          align: 'center',
          key: 'perTypeName',
          width: 150,
        },
        {
          title: ' '
        },
        {
          title: '开始日期',
          align: 'center',
          key: 'beginDate',
          width: 110,
          render: (h, params) => {
            return h('span', {}, this.format(params.row['beginDate'],false))
          }
        },
        {
          title: ' '
        },
        {
          title: '结束日期',
          align: 'center',
          key: 'endDate',
          width: 110,
          render: (h, params) => {
            return h('span', {}, this.format(params.row['endDate'],false))
          }
        },
        {
          title: ' '
        },
        {
          title: '创建人',
          align: 'center',
          key: 'createBy',
          width: 100,
        },
        {
          title: ' '
        },
        {
          title: '创建时间',
          align: 'center',
          key: 'createTime',
          width: 160,
          render: (h, params) => {
            return h('span', {}, this.format(params.row['createTime']))
          }
        },
        {
          title: ' '
        },
        {
          title: '状态',
          align: 'center',
          key: 'isUse',
          width: 60,
          render(h,params){
            return h('span', {}, params.row['isUse'] === 1 ? '启用' : '停用')
          }
        },
        {
          title: ' '
        },
        {
          title: '操作',
          align: 'center',
          width: 120,
          fixed: 'right',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'formulaConf/enableOrNot'
                    }
                  }
                ],
                on: {
                  click: () => {
                    let state = params.row['isUse'] === 1 ? '停用' : '启用';
                    this.$Modal.confirm({
                      title: state+'公式',
                      content: '<p>确认'+state+'本条公式？</p>',
                      onOk: () =>{
                        let isUseParams = params.row['isUse'] === 1? 2 : 1;
                        const params1 = {
                          formulaConfFid:params.row['formulaConfFid'],
                          isUse: isUseParams
                        }
                        enableOrNot(params1)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success(state+'成功')
                            this.getTableList();
                          }
                        })
                        .catch( err => {
                          this.$Message.info( state+'失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                },
                style: {
                  marginRight: '10px'
                }
              }, params.row['isUse'] === 1 ? '停用' : '启用'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'formulaConf/deleteFormulaConf'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除公式',
                      content: '<p>确认删除本条公式？</p>',
                      onOk: () => {
                        const params2 = {
                          formulaConfFid:params.row['formulaConfFid']
                        }
                        deleteFormulaConf(params2)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('删除成功')
                            this.getTableList();
                          }
                        })
                        .catch( err => {
                          this.$Message.info( '删除失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                }
              }, '删除')
            ]
          }
        },
        {
          title: ' '
        },
      ]
    }
  },
  created(){
    this.getProjectsData();
    this.getQueryData();
  },
  methods:{
    getProjectsData(){
      getProjects()
      .then(res => {
        this.projectList = res.data;
      })
    },
    getQueryData(){
      queryData()
      .then( res => {
        this.sceneList = res.data.sceneList;
        this.roleList = res.data.roleList;
      })
    },
    search(data){
      this.searchParams = data;
      this.page=1
      this.current=1
      this.getTableList();
    },
    getTableList(){
      let params= {
        ...this.searchParams,
        page:this.page,
        limit:this.limit
      }
      formulaConfListByPage(params)
      .then( res => {
        this.data = res.data.rows
        this.total = res.data.total
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getTableList()
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    }
  }
}
</script>

<style>

</style>
